import { components } from "@/api-schema";

type AppRole = components["schemas"]["AppRole"];
type AttributeBranch = NonNullable<AppRole["attributeBranch"]>;
type AttributeCompany = NonNullable<AppRole["attributeCompany"]>;
type AttributeCompanyGroup = NonNullable<AppRole["attributeCompanyGroup"]>;

const renderBranchAttribute = (branch: AttributeBranch): string => {
  const { technicalId, name, address } = branch;
  const { postalCode, city, street, houseNumber } = address;

  const parts: string[] = [];

  if (name) parts.push(name);

  const cityPart = [postalCode, city].filter(Boolean).join(" ");
  if (cityPart) parts.push(cityPart);

  const streetPart = [street, houseNumber].filter(Boolean).join(" ");
  if (streetPart) parts.push(streetPart);

  const branchDetails = parts.join(", ");

  return `${technicalId}${branchDetails && " (" + branchDetails + ")"}`;
};

const renderNamedAttribute = (attribute: AttributeCompany | AttributeCompanyGroup): string => {
  const { technicalId, name } = attribute;
  return name ? `${technicalId} (${name})` : technicalId;
};

export const renderAttributeAppRole = (appRole: AppRole): string => {
  if (appRole.attributeBranch != null) {
    return renderBranchAttribute(appRole.attributeBranch);
  }

  if (appRole.attributeCompany != null) {
    return renderNamedAttribute(appRole.attributeCompany);
  }

  if (appRole.attributeCompanyGroup != null) {
    return renderNamedAttribute(appRole.attributeCompanyGroup);
  }

  return appRole.name;
};
